import {
  RESULT_ESTIMATE_PERFORMANCE_FETCHING,
  RESULT_ESTIMATE_PERFORMANCE_FAILED,
  RESULT_ESTIMATE_PERFORMANCE_SUCCESS,
} from "../actions/types";

const initialState = {
  result: null,
  isFetching: false,
  isError: false,
};

export default function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case RESULT_ESTIMATE_PERFORMANCE_FETCHING:
      return { ...state, result: null, isFetching: true, isError: false };
    case RESULT_ESTIMATE_PERFORMANCE_FAILED:
      return { ...state, result: null, isFetching: false, isError: true };
    case RESULT_ESTIMATE_PERFORMANCE_SUCCESS:
      return { ...state, result: payload, isFetching: false, isError: false };
    default:
      return state;
  }
}
